import { useEffect } from 'react';

export function proposalDeliveryRedirect(input: {
  currentStep: string;
  proposalId?: string;
  isCartValid: boolean;
  isConfigurationValid: boolean;
  isDeliveryComplete: boolean;
}): string | null {
  if (!['delivery', 'resume'].includes(input.currentStep)) return null;
  if (!input.proposalId) return 'client';
  if (!input.isCartValid) return 'cart';
  if (input.currentStep === 'resume' && !input.isDeliveryComplete) return 'delivery';
  return null;
}

export function useProposalDeliveryGuard(
  input: Parameters<typeof proposalDeliveryRedirect>[0] & {
    isLoading: boolean;
    redirect: (step: string) => void;
  },
): boolean {
  const { isLoading, proposalId, redirect } = input;
  const target = proposalDeliveryRedirect(input);
  const protectedStep = ['delivery', 'resume'].includes(input.currentStep);
  useEffect(() => {
    if (target && (!isLoading || !proposalId)) redirect(target);
  }, [target, isLoading, proposalId, redirect]);
  return !protectedStep || (!isLoading && !target);
}
